import { gql } from "@outschool/ui-apollo";

export const recentlyCompletedClassesQuery = gql`
  query RecentlyCompletedClassesQuery(
    $end: DateTime
    $learnerUid: String
    $limit: Int
  ) {
    currentUser {
      uid
      learners {
        uid
        name
      }
      enrollmentsForTranscript(
        end: $end
        learnerUid: $learnerUid
        limit: $limit
      ) {
        uid
        confirmed_at
        withdrawn_at
        ongoing_start_time
        ongoingEndTime
        learner {
          uid
          name
          avatar
        }
        section {
          uid
          canceled_at
          start_time
          end_time
          leader {
            uid
            name
            leader_link
            photo
          }
          activity {
            uid
            title
            details {
              photo
            }
            isSelfPaced
            isOneTime
            hasTeacherSchedule
            size_max
          }
          meetings {
            uid
            start_time
            end_time
          }
          currentUserPublicReview {
            uid
            currentUserCanEdit
          }
        }
      }
    }
  }
`;
